import clsx from "clsx";
import { useCallback, useState } from "react";
import { useStyles } from "./ZoomableImage.styles";

export type Props = {
  src: string;
};

export const ZoomableImage = ({ src }: Props) => {
  const classes = useStyles();
  const [active, setActive] = useState(false);

  const handleImageClick = useCallback(() => {
    setActive(!active);
  }, [active]);

  return (
    <>
      {active && (
        <div className={classes.backdrop} onClick={handleImageClick} />
      )}
      <div
        className={clsx(classes.imageWrapper, { active: active })}
        onClick={handleImageClick}
      >
        <img src={src} />
      </div>
    </>
  );
};
